import stanfordSealAssetUrl from 'branding/assets/stanford-seal.png';
import stanfordWordmarkAssetUrl from 'branding/assets/stanford-wordmark.png';

/**
 * Static path (served from the webapp's `public/` directory, not Firebase
 * Storage) of the cardinal-red Stanford seal. This exact path is baked as
 * literal data into every slide deck's persisted default-logo element (see
 * `slides/schema/deck.ts`'s `DEFAULT_LOGO_SRC` and `createMasterLogoElement`),
 * so it must never change or be fingerprinted — doing so would orphan the
 * image reference in every deck already saved to Firestore. `deck.ts` is the
 * only intended consumer; every other (non-persisted, live-rendered) usage
 * should use {@link STANFORD_LOGO_ASSET_SRC} or the {@link StanfordLogo}
 * component instead, which get the bundler's fingerprinting/caching benefits.
 */
export const STANFORD_LOGO_SRC = '/stanford.png';

/**
 * Bundler-imported (fingerprinted, long-term cacheable) copy of the same
 * Stanford seal image as {@link STANFORD_LOGO_SRC}, for every live-rendered
 * usage that isn't persisted as data. Prefer the {@link StanfordLogo}
 * component over importing this directly.
 */
export const STANFORD_LOGO_ASSET_SRC: string = stanfordSealAssetUrl;

/**
 * Bundler-imported (fingerprinted, long-term cacheable) white Stanford
 * wordmark (text lockup), used on dark backgrounds alongside
 * {@link STANFORD_LOGO_ASSET_SRC}. Has no persisted-data usage, so it carries
 * no legacy-path constraint the way {@link STANFORD_LOGO_SRC} does.
 */
export const STANFORD_WORDMARK_SRC: string = stanfordWordmarkAssetUrl;
